import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-box game-edit" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Image", -1)
const _hoisted_9 = ["textContent"]
const _hoisted_10 = {
  key: 0,
  class: "current-image"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "price" }, "Price", -1)
const _hoisted_14 = ["textContent"]
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, "Date", -1)
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { class: "field field-select" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "store" }, "Store", -1)
const _hoisted_20 = ["textContent"]
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "website" }, "Website", -1)
const _hoisted_23 = ["textContent"]
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "hashtag" }, "Hashtag", -1)
const _hoisted_26 = ["textContent"]
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "developer" }, "Developer", -1)
const _hoisted_29 = ["textContent"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "purchase-section" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-plus" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "purchases" }
const _hoisted_35 = { class: "field" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "review" }, "Review", -1)
const _hoisted_37 = ["textContent"]
const _hoisted_38 = { class: "field field-checkbox" }
const _hoisted_39 = ["checked"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "completed" }, "Completed", -1)
const _hoisted_41 = ["textContent"]
const _hoisted_42 = { class: "buttons" }
const _hoisted_43 = ["textContent"]

import { ref, reactive, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { Actions, Mutations } from '@/store';
import { Game, ProductTypes } from '@/models/game.model';
import Product from '@/models/product.model';
import { Store, StoreType } from '@/models/store.model';
import GameRating from './GameRating.vue';
import ProductItem from '@/components/product/ProductItem.vue';
import Choice, { Item } from '@/components/choice/Choice.vue';
import ImageEdit from '@/components/image-edit/ImageEdit.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameEdit',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const game = reactive<Game>(new Game());

const imageData = ref<any>('');
const removedImage = ref<any>('');
const isEdit = ref<boolean>(false);
const types = ref<Item[]>([
  { value: ProductTypes.DLC, label: 'DLC' },
  { value: ProductTypes.AddOn, label: 'Add-On' },
  { value: ProductTypes.ExpansionPass, label: 'Expansion Pass' },
  { value: ProductTypes.SeasonPass, label: 'Season Pass' },
  { value: ProductTypes.Subscription, label: 'Subscription' },
]);

const stores = computed<Store[]>(() => store.state.stores);

const action = computed<string>(() => {
  return isEdit.value ? 'Edit' : 'Add';
});
const title = computed<string>(() => {
  return action.value + ' game';
});
const storeOptions = computed<Item[]>(() => {
  return stores.value
    .filter((s) => s.type !== StoreType.HardwareStore)
    .map((s) => {
      return {
        value: s.id,
        label: s.name,
      };
    });
});

onMounted(async () => {
  await store.dispatch(Actions.GetStores);
  if (~route.path.indexOf('edit') && !store.state.item) {
    // on reload
    isEdit.value = true;
    store
      .dispatch(Actions.GetGameByName, route.params.title)
      .then((g: Game) => {
        Object.assign(game, g);
      });
  } else if (store.state.item) {
    // on edit from another page
    isEdit.value = true;
    Object.assign(game, store.state.item);
  } else {
    // get all purchases first, so that adding a game works correctly
    store.dispatch(Actions.GetGames);
    Object.assign(game, new Game());
  }
});

const cancel = () => {
  if (removedImage.value) {
    game.image = removedImage.value;
  }
  store.commit(Mutations.SetViewItem, null);
  router.push('/');
};
const submit = async () => {
  if (game.isValid()) {
    const data = game.data();
    const formData = new FormData();
    formData.append('game', JSON.stringify(data));
    if (imageData.value) {
      formData.append('imageData', imageData.value);
    }
    if (removedImage.value) {
      await store.dispatch(Actions.RemoveGameImage, removedImage.value);
    }
    const response = await store.dispatch(Actions.UpdateGameItem, {
      item: formData,
      originalItem: game,
      url: game.url,
      edit: isEdit.value,
    });
    if (response.status) {
      cancel();
    }
  }
};

const addPurchase = () => {
  game.addPurchase(new Product());
};

const updateImage = (data: any) => {
  imageData.value = data;
};

const removeImage = async () => {
  removedImage.value = game.image;
  game.image = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", {
      textContent: _toDisplayString(_unref(title))
    }, null, 8, _hoisted_2),
    game
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              name: "name",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((game.name) = $event))
            }, null, 512), [
              [_vModelText, game.name]
            ]),
            (!game.isValid('name'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(game.validation.messages.name)
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(ImageEdit, { onUpdate: updateImage }),
            (!game.isValid('name'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(game.validation.messages.name)
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          (game.image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: `/api/images/${game.image}`
                }, null, 8, _hoisted_11),
                _createElementVNode("button", {
                  type: "button",
                  class: "icon-only danger icon-close",
                  onClick: removeImage
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "price",
              placeholder: "0.00",
              lang: "en-US",
              step: "0.01",
              id: "price",
              name: "price",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((game.price) = $event))
            }, null, 512), [
              [
                _vModelText,
                game.price,
                void 0,
                { number: true }
              ]
            ]),
            (!game.isValid('price'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(game.validation.messages.price)
                }, null, 8, _hoisted_14))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "date",
              id: "date",
              name: "date",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((game.date) = $event))
            }, null, 512), [
              [_vModelText, game.date]
            ]),
            (!game.isValid('date'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(game.validation.messages.date)
                }, null, 8, _hoisted_17))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(Choice, {
              modelValue: game.store,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((game.store) = $event)),
              id: "store",
              items: _unref(storeOptions)
            }, null, 8, ["modelValue", "items"]),
            (!game.isValid('store'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(game.validation.messages.store)
                }, null, 8, _hoisted_20))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "website",
              placeholder: "http://",
              id: "website",
              name: "website",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((game.website) = $event))
            }, null, 512), [
              [_vModelText, game.website]
            ]),
            (!game.isValid('website'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(game.validation.messages.website)
                }, null, 8, _hoisted_23))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "hashtag",
              placeholder: "#",
              id: "hashtag",
              name: "hashtag",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((game.hashtag) = $event))
            }, null, 512), [
              [_vModelText, game.hashtag]
            ]),
            (!game.isValid('hashtag'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(game.validation.messages.hashtag)
                }, null, 8, _hoisted_26))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "developer",
              name: "developer",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((game.developer) = $event))
            }, null, 512), [
              [_vModelText, game.developer]
            ]),
            (!game.isValid('developer'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(game.validation.messages.developer)
                }, null, 8, _hoisted_29))
              : _createCommentVNode("", true)
          ]),
          (isEdit.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
                _createElementVNode("section", _hoisted_31, [
                  _createElementVNode("h2", null, [
                    _createTextVNode(" Purchases "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: addPurchase,
                      class: "icon-only"
                    }, _hoisted_33)
                  ]),
                  _createElementVNode("ul", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(game.purchases, (product, index) => {
                      return (_openBlock(), _createBlock(ProductItem, {
                        product: product,
                        key: product.key,
                        types: types.value,
                        index: index
                      }, null, 8, ["product", "types", "index"]))
                    }), 128))
                  ])
                ]),
                _createVNode(GameRating, {
                  modelValue: game.rating,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((game.rating) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _withDirectives(_createElementVNode("textarea", {
                    id: "review",
                    name: "review",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((game.review) = $event))
                  }, null, 512), [
                    [_vModelText, game.review]
                  ]),
                  (!game.isValid('review'))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-validation",
                        textContent: _toDisplayString(game.validation.messages.review)
                      }, null, 8, _hoisted_37))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "completed",
                    name: "completed",
                    checked: game.completed,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((game.completed) = $event))
                  }, null, 8, _hoisted_39), [
                    [_vModelCheckbox, game.completed]
                  ]),
                  _hoisted_40,
                  (!game.isValid('completed'))
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-validation",
                        textContent: _toDisplayString(game.validation.messages.completed)
                      }, null, 8, _hoisted_41))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", {
              type: "button",
              class: "cancel",
              onClick: cancel
            }, "Cancel"),
            _createElementVNode("button", {
              type: "submit",
              textContent: _toDisplayString(_unref(action))
            }, null, 8, _hoisted_43)
          ])
        ], 40, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})